import { render, staticRenderFns } from "./DashboardListDeleteDialogue.vue?vue&type=template&id=5ebc67ca&scoped=true&"
import script from "./DashboardListDeleteDialogue.vue?vue&type=script&lang=ts&"
export * from "./DashboardListDeleteDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardListDeleteDialogue.vue?vue&type=style&index=0&id=5ebc67ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc67ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon})
